// Polyfill for Promise.withResolvers (ES2024). pdf.js 4.x calls it at import
// time. It is missing on Node 20 (vitest) and on pre-2024 mobile browsers
// (iOS Safari < 17.4, Chrome < 119) — the phones this viewer exists for.
// Import this module BEFORE react-pdf.

interface WithResolvers<T> {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
}

declare global {
  interface PromiseConstructor {
    withResolvers<T>(): WithResolvers<T>;
  }
}

if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers<T>(this: PromiseConstructor): WithResolvers<T> {
    let resolve!: WithResolvers<T>["resolve"];
    let reject!: WithResolvers<T>["reject"];
    const promise = new this<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

export {};
